document.addEventListener('DOMContentLoaded', function() {

  // Scroll reveal
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) entry.target.classList.add('visible');
      });
    },
    { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
  );
  document.querySelectorAll('.reveal').forEach((el) => observer.observe(el));

  // Nav scroll
  const navbar = document.getElementById('navbar');
  if (navbar) {
    window.addEventListener('scroll', () => {
      if (window.scrollY > 80) navbar.classList.add('nav-scrolled');
      else navbar.classList.remove('nav-scrolled');
    }, { passive: true });
  }

  // Smooth scroll
  document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();
      const target = document.querySelector(this.getAttribute('href'));
      if (target) {
        const offset = 130;
        const top = target.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({ top, behavior: 'smooth' });
      }
    });
  });

});

// Accordion
function toggleAccordion(trigger) {
  const item = trigger.closest('.accordion-item');
  const isOpen = item.classList.contains('open');
  document.querySelectorAll('.accordion-item').forEach((i) => i.classList.remove('open'));
  if (!isOpen) item.classList.add('open');
}

// Mobile menu
let mobileMenuOpen = false;
function toggleMobileMenu() {
  mobileMenuOpen = !mobileMenuOpen;
  const menu = document.getElementById('mobile-menu');
  const toggle = document.getElementById('mobile-menu-toggle');
  if (mobileMenuOpen) {
    menu.style.maxHeight = menu.scrollHeight + 'px';
    toggle.classList.add('mobile-menu-open');
  } else {
    menu.style.maxHeight = '0';
    toggle.classList.remove('mobile-menu-open');
  }
}
function closeMobileMenu() {
  mobileMenuOpen = false;
  document.getElementById('mobile-menu').style.maxHeight = '0';
  document.getElementById('mobile-menu-toggle').classList.remove('mobile-menu-open');
}

// Review filtering
function filterReviews(tag) {
  document.querySelectorAll('.review-filter').forEach(btn => {
    btn.classList.remove('active', 'review-filter-active');
    btn.classList.add('review-filter-inactive');
  });
  event.currentTarget.classList.add('active', 'review-filter-active');
  event.currentTarget.classList.remove('review-filter-inactive');
  document.querySelectorAll('.review-card').forEach(card => {
    const tags = card.getAttribute('data-tags').split(' ');
    if (tag === 'all' || tags.includes(tag)) {
      card.style.display = '';
      card.style.opacity = '1';
      card.style.transform = 'translateY(0)';
    } else {
      card.style.opacity = '0';
      card.style.transform = 'translateY(8px)';
      setTimeout(() => { card.style.display = 'none'; }, 300);
    }
  });
}
